import { WarningStep } from "#/components/carrot-card-cost-share/steps/variants/WarningStep"
import { Link } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"

export function CarrotCardCantBeUsedStep(): JSX.Element {
  const intl = useIntl()
  return (
    <WarningStep
      title={intl.formatMessage({ defaultMessage: "Carrot Card can’t be used for this expense." })}
      primaryDescription={intl.formatMessage(
        {
          defaultMessage:
            "However, you can use another payment method for <link>eligible expenses</link> and submit a reimbursement request. "
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to={DbgPaths.CARROT_ELIGIBLE}
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
      secondaryDescription={intl.formatMessage(
        {
          defaultMessage: "Please <link>contact us</link> with any questions."
        },
        {
          link: (linkContent) => (
            <Link component={RouterLink} to="/care-team" color="inherit" target="_blank" rel="noopener noreferrer">
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
